// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"Loading_ldsRing__1yZdy"};